/* 定数定義 */
export namespace SysConst {
    /* Router Path */
    export namespace Path {
        /* アプリケーションが配置されるパス */
        export const APP_BASE = '/trials/';

        /* ROOT */
        export const ROOT = '/';

        /* プライバシーポリシー */
        export const PRIVACY_POLICY = '/tos';

        /* 試行 メニュー */
        export const TRIALS_MENU = '/trials';

        /* 学習 データ メニュー */
        export const TRAIN_DATA_MENU = '/train/data';

        /* 学習 データ アップロード */
        export const TRAIN_DATA_UPLOAD = '/train/data/upload';

        /* 学習 データ 統計情報 */
        export const TRAIN_DATA_STATISTICS = '/train/data/statistics';

        /* 学習 データ 統計情報 欠損値*/
        export const TRAIN_DATA_STATISTICS_NA = '/train/data/statistics/na';

        /* 学習 データ 統計情報 ラベル*/
        export const TRAIN_DATA_STATISTICS_LABELS = '/train/data/statistics/labels';

        /* 学習データ KC取得中 */
        export const TRAIN_DATA_GETTING_KC_LIST = '/train/data/getting/kc';

        /* Knowledge Chunk メニュー */
        export const TRAIN_KC_MENU = '/train/kc';

        /* Knowledge Chunk 列挙 */
        export const TRAIN_KC_LIST = '/train/kc/list';

        /* Knowledge Chunk 学習中 */
        export const TRAIN_KC_TRAINING = '/train/kc/training';

        /* 学習 結果 メニュー  */
        export const TRAIN_RESULT_MENU = '/train/result';

        /* 学習 結果 全体 */
        export const TRAIN_RESULT_ALL = '/train/result/all';

        /* 学習 結果 パラメータ */
        export const TRAIN_RESULT_ALL_PARAMS = '/train/result/all/params';

        /* 学習 結果 Knowledge Chunks */
        export const TRAIN_RESULT_ALL_KC = '/train/result/all/kc';

        /* 学習 結果 データ一覧 */
        export const TRAIN_RESULT_DATA = '/train/result/data';

        /* 学習 結果 データ一覧 バイナリ化前 */
        export const TRAIN_RESULT_DATA_BEFORE = '/train/result/data/before';

        /* 学習 結果 データ一覧 バイナリ化後 */
        export const TRAIN_RESULT_DATA_AFTER = '/train/result/data/after';

        /* 予測 データ メニュー */
        export const PREDICT_DATA_MENU = '/predict/data';

        /* 予測 データ アップロード */
        export const PREDICT_DATA_UPLOAD = '/predict/data/upload';

        /* 予測 データ 統計情報 */
        export const PREDICT_DATA_STATISTICS = '/predict/data/statistics';

        /* 予測 データ 統計情報 全体*/
        export const PREDICT_DATA_STATISTICS_ALL = '/predict/data/statistics/all';

        /* 予測 データ 統計情報 欠損値*/
        export const PREDICT_DATA_STATISTICS_NA = '/predict/data/statistics/na';

        /* 予測 データ 予測中 */
        export const PREDICT_DATA_PREDICTING = '/predict/data/predicting';

        /* 予測 結果 メニュー */
        export const PREDICT_RESULT_MENU = '/predict/result';

        /* 予測 結果 データ一覧 */
        export const PREDICT_RESULT_DATA = '/predict/result/data';
    }

    /* 事例サンプルデータ名 */
    export namespace Samples {
        /* マーケティング */
        export const MARKETING = 'marketing';

        /* ヘルスケア */
        export const HEALTHCARE = 'healthcare';

        /* 金融 */
        export const FINANCE = 'finance';

        /* 中学生向け */
        export const FOR_MIDDLE_SCHOOLER = 'middle_schooler';
    }

    /* バックエンドAPI */
    export namespace Api {
        /* パス */
        export namespace Path {
            /* トークン取得 */
            export const GET_TOKEN = '/api/token';

            /* トークン取り消し */
            export const DELETE_TOKEN = '/api/token';

            /* 学習データ登録 */
            export const REGIST_TRAINING_SETS = '/api/training_sets';

            /* 学習データ指定 */
            export const SELECT_TRAINING_SETS = '/api/training_sets/select';

            /* 最後にアップロードした学習データ取得 */
            export const GET_TRAINING_SETS = '/api/training_sets/current';

            /* モデル作成要求 */
            export const START_CREATE_MODEL = '/api/models';

            /* 作成が完了したモデルの学習データの行毎のナレッジチャンク取得 */
            export const GET_KC_FOR_TRAINING_SET = '/api/models/current/individuals/';

            /* 作成が完了したモデルのナレッジチャンク取得 */
            export const GET_KC_LIST_FOR_MODEL = '/api/models/current/knowledgechunk';

            /* 作成が完了したモデルの学習パラメータとスコア取得 */
            export const GET_PARAMS_AND_SCORES = '/api/models/current/parameter';

            /* 作成が完了したモデルの学習データ取得 */
            export const GET_PREPROCESSED_TRAINING_SETS = '/api/models/current/prepared_set';

            /* モデル作成要求の進捗状況取得 */
            export const GET_MODEL_CREATION_STATE = '/api/models/current/status';

            /* 予測データ登録 */
            export const REGIST_PREDICTION_SETS = '/api/prediction_sets';

            /* 予測データ選択 */
            export const SELECT_PREDICTION_SETS = '/api/prediction_sets/select';

            /* 最後にアップロードした予測データ取得 */
            export const GET_PREDICTION_SETS = '/api/prediction_sets/current';

            /* 予測要求 */
            export const START_PREDICTION = '/api/predictions';

            /* 完了した予測データの行毎のナレッジチャンク取得 */
            export const GET_KC_FOR_PREDICTION_SET = '/api/predictions/current/individuals/';

            /* 完了した予測の予測データ取得 */
            export const GET_PREPROCESSED_PREDICTION_SETS = '/api/predictions/current/prepared_set';

            /* 完了した予測の結果取得 */
            export const GET_PREDICTION_RESULT = '/api/predictions/current/result';

            /* 予測要求の進捗状況取得 */
            export const GET_PREDICTION_STATE = '/api/predictions/current/status';
        }
    }
    /* 入力データ(CSV) */
    export namespace InputData {
        /* データ型 */
        export namespace Type {
            /* 文字列データ */
            export const STRING = 'string';

            /* 数値データ */
            export const NUMBER = 'number';
        }
    }
    export namespace OutputData {
        export namespace KC {
            export namespace Limit {
                export const POS = 50;
                export const NEG = 50;
            }
        }
    }
    /* 色 */
    export namespace Color {
        /* ポジティブ */
        export const POSITIVE = '#ff5eD8';
        /* ネガティブ */
        export const NEGATIVE = '#748aff';
        /* ボタン */
        export namespace Button {
            export namespace Next {
                export const BG = '#24C6F2';
            }
            export namespace Clear {
                export const BG = '#999999';
            }
        }
    }
    /* ダイアログ */
    export namespace Dialog {
        /* 幅 */
        export const WIDTH = 900;
    }
    /* フラグ */
    export namespace Flag {
        /* 処理の状態 */
        export namespace Process {
            /* 未実施 */
            export const TODO = 0;
            /* 実施中 */
            export const DOING = 1;
            /* 実施済 */
            export const DONE = 2;
        }
    }
}
